var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25065 8.60433C5.10565 8.60433 0.833984 9.67683 0.833984 11.8127V13.4168H13.6673V11.8127C13.6673 9.67683 9.39565 8.60433 7.25065 8.60433ZM2.97898 11.5835C3.74898 11.0518 5.60982 10.4377 7.25065 10.4377C8.89148 10.4377 10.7523 11.0518 11.5223 11.5835H2.97898ZM7.25065 7.00016C9.01982 7.00016 10.459 5.561 10.459 3.79183C10.459 2.02266 9.01982 0.583496 7.25065 0.583496C5.48148 0.583496 4.04232 2.02266 4.04232 3.79183C4.04232 5.561 5.48148 7.00016 7.25065 7.00016ZM7.25065 2.41683C8.01148 2.41683 8.62565 3.031 8.62565 3.79183C8.62565 4.55266 8.01148 5.16683 7.25065 5.16683C6.48982 5.16683 5.87565 4.55266 5.87565 3.79183C5.87565 3.031 6.48982 2.41683 7.25065 2.41683ZM13.704 8.65933C14.7673 9.42933 15.5007 10.456 15.5007 11.8127V13.4168H19.1673V11.8127C19.1673 9.961 15.959 8.90683 13.704 8.65933ZM12.7507 7.00016C14.5198 7.00016 15.959 5.561 15.959 3.79183C15.959 2.02266 14.5198 0.583496 12.7507 0.583496C12.2557 0.583496 11.7973 0.702663 11.3757 0.904329C11.9532 1.72016 12.2923 2.71933 12.2923 3.79183C12.2923 4.86433 11.9532 5.8635 11.3757 6.67933C11.7973 6.881 12.2557 7.00016 12.7507 7.00016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.98688a7f701b96b65018a785785f810e.svg";
export { ForwardRef as ReactComponent };